<template>
  <div class="panel">
    <div class="panel-header">
      <h3 class="panel-header-title">Datos del proveedor</h3>
    </div>
    <div class="panel-body">
      <div class="divide-gray-200">
        <div class="grid grid-cols-1 gap-y-8 gap-x-4 sm:grid-cols-6">
          <div class="sm:col-span-3">
            <dt class="label-data">Código</dt>
            <dd class="content-data">
              {{ provider.ae_code }}
            </dd>
          </div>
          <div class="sm:col-span-3">
            <dt class="label-data">Nombre legal</dt>
            <dd class="content-data">
              {{ provider.entity?.legal_name }}
            </dd>
          </div>
          <div class="sm:col-span-3">
            <dt class="label-data">Organismo de certificación</dt>
            <dd class="content-data">
              {{ provider.certifier?.name }}
            </dd>
          </div>
          <div class="sm:col-span-3">
            <dt class="label-data">CU / N° Registro</dt>
            <dd class="content-data">
              {{ provider.certifier_code }}
            </dd>
          </div>
          <div class="sm:col-span-3">
            <dt class="label-data">Encargado de certificaciones</dt>
            <dd class="content-data">
              {{ provider.manager?.name }}
            </dd>
          </div>
          <div class="sm:col-span-3">
            <dt class="label-data">Celular</dt>
            <dd class="content-data">
              {{ provider.manager?.mobile_number }}
            </dd>
          </div>
          <div class="sm:col-span-3">
            <dt class="label-data">Correo</dt>
            <dd class="content-data">
              {{ provider.manager?.email }}
            </dd>
          </div>
        </div>
      </div>
    </div>
    <div class="panel-footer">
      <div class="panel-footer-actions">
        <edit-button @click.prevent="goToEditProvider()" label="Editar" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AECertificationsProvidersProviderInfo",
  props: {
    agro_exporter_id: { required: true },
    provider_id: { required: true },
    provider_type: { type: String, required: true },
    provider: {
      type: Object,
      required: true
    }
  },
  methods: {
    goToEditProvider() {
      this.$router.push({
        name: this.routeName("manage_provider"),
        params: {
          provider_id: this.provider_id,
          agro_exporter_id: this.agro_exporter_id,
          provider_type: this.provider_type
        }
      });
    }
  }
};
</script>
